module.exports = __webpack_public_path__ + "img/thumb_16.a9fbb51f.jpg";